// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { environmentApi } from './environment.api';
import { environmentReports } from './environment.reports';

export const environment = {
  bceLink: 'https://dev.msbce.com',
  hmr: false,
  name: 'local',
  production: false,
  spaceGeekUrl: 'https://localhost:44365/api/',
  apiBaseUrl: 'apidev.workspacegeek.com',
  api: environmentApi,
  reports: environmentReports,
  reportServerUrl: 'https://reportsdev.workspacegeek.com/ReportLoader.aspx?',
  scripts: {
    forte: 'https://checkout.forte.net/v1/js',
    placePay: 'https://rentshare.com/plugins/pay.js'
  },
  webApiUrl: 'http://localhost:44365/api/',
  wsgExternalUrl: 'https://staging.workspacegeek.com',
  trwBaseUrl: 'https://app.msptrw.com',
  networkCommanderBaseUrl: 'https://workspacegeek.networkcommander.com',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
